import { Collapse, Space, Table, Tabs, Row, Col, Tag } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import qs from 'qs';
import Axios from 'axios';
import Select from 'react-select';
import toaster from 'helper/toaster';
import DashboardContext from 'Context';
import TabelWorker from './TabelWorker';
import { useHistory } from 'react-router-dom';
import Switchrs from 'components/inputs/Switchrs';
import InputControl from 'components/inputs/InputControl';
import CustomPagination from 'components/table/pagination';
import ModalJobDispatchWorker from './ModalJobDispatchWorker';
import NewSpecialitiesCollapse from 'components/forms/NewSpecialitiesCollapse';
import CreateWorkerFromVoluntary from 'components/forms/workerActions/CreateWorkerFromVoluntary';
import InputControlAsync from 'components/inputs/InputControlAsync';

/**
 * این کامپوننت برای نمایش مدال افزودن نیرو است
 * در جدول سفارشات و نیرو ها است
 */

const ModalCreateworker = ({
  showitem,
  handleCloseMoudal,
  id,
  handleRefreshGridWorker,
  isContractual = false,
  isB2B = false,
}) => {
  const [tabPane, setTabPane] = useState(1);
  const [reloadTab, setReloadTab] = useState(false);

  const { sideBardata, authentication, urldashboard, handelerrors } =
    useContext(DashboardContext);

  const onChange = (value) => {
    setTabPane(value);
    value === '1' ? setReloadTab(true) : setReloadTab(false);
  };

  return (
    <>
      <Modal show={showitem} onHide={handleCloseMoudal} size={'lg'}>
        <Modal.Header>
          <Modal.Title>افزودن نیرو</Modal.Title>
          <i
            className='fa fa-times mr-auto'
            style={{ fontSize: '16px', cursor: 'pointer' }}
            onClick={handleCloseMoudal}
            aria-hidden='true'
          ></i>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col span={24}>
              <Tabs
                defaultActiveKey={'1'}
                onChange={onChange}
                items={[
                  {
                    label: `عادی`,
                    key: '1',
                    children: (
                      <TabPane1
                        contextData={{
                          sideBardata,
                          authentication,
                          urldashboard,
                          id,
                          handleRefreshGridWorker,
                          isContractual,
                          reloadTab,
                          isB2B
                        }}
                      />
                    ),
                  },
                  {
                    label: `پیشنهادی`,
                    key: '2',
                    children: (
                      <TabPane2
                        contextData={{
                          sideBardata,
                          authentication,
                          urldashboard,
                          id,
                          handelerrors,
                          isContractual,
                          isB2B
                        }}
                      />
                    ),
                  },
                  ...(isContractual
                    ? [
                        {
                          label: 'داوطلبی',
                          key: '3',
                          children: (
                            <TabPane3
                              contextData={{
                                sideBardata,
                                authentication,
                                urldashboard,
                                id,
                                handelerrors,
                              }}
                            />
                          ),
                        },
                      ]
                    : []),
                  ...(isContractual
                    ? [
                        {
                          label: 'نیروهای مناسب',
                          key: '4',
                          children: (
                            <TabPane4
                              contextData={{
                                sideBardata,
                                authentication,
                                urldashboard,
                                id,
                                handelerrors,
                              }}
                            />
                          ),
                        },
                      ]
                    : []),
                ]}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

const TabPane1 = ({ contextData }) => {
  const [arryactions, setArryactions] = useState([]);
  const { location } = useHistory();
  const [arrystate, setArrystate] = useState([]);
  const [loadingFrom, setLoadingFrom] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [localReload, setReload] = useState(false);
  const [formData, setFormData] = useState({
    orderScheduleId: contextData?.id,
  });

  const [controllerName, setControllerName] = useState(
    location.pathname.split('/')[1].replace('/', '')
  );

  const dataFeching = async (specificationIds = []) => {
    try {
      setIsLoading(true);
      const res = await Axios.post(
        `${contextData?.urldashboard}/worker/available`,
        JSON.stringify({ orderScheduleId: contextData?.id, specificationIds }),
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      // eslint-disable-next-line no-unused-expressions
      const data = await res.data.data;
      setArrystate(data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (error.message === 'Network Error') {
        toaster.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید');
      } else {
        toaster.error(error.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    contextData?.reloadTab && setReload(!localReload);
  }, [contextData?.reloadTab]);

  useEffect(() => {
    dataFeching();

    if (contextData?.sideBardata) {
      contextData?.sideBardata.map((item) => {
        item.controllers.filter((find) => {
          if (`/${find.controller}` === '/WorkerOrderSchedule') {
            setArryactions(find.actions);
            return find;
          }
        });
      });
    }

    if (location.pathname.includes('Customer')) {
      setControllerName('order');
    }
  }, [localReload]);

  const handelValue = (name, value) => {
    switch (name) {
      case 'workerId':
        setFormData({ ...formData, workerId: value });
        break;
      case 'ignoreFormOrder':
        setFormData({ ...formData, ignoreFormOrder: value });
        break;
      case 'isFavorite':
        setFormData({ ...formData, isFavorite: value });
        break;
      case 'hasAdditionalService':
        setFormData({ ...formData, hasAdditionalService: value });
        break;
      case 'hasAlternative':
        setFormData({ ...formData, hasAlternative: value });
        break;
      case 'presenterId':
        setFormData({ ...formData, presenterId: value });
        break;
      default:
        break;
    }
  };

  const [checkModal, setCheckModal] = useState(false);
  const [checkingMessage, setCheckingMessage] = useState('');
  const [selectedWorkerId, setSelectedWorkerId] = useState('');

  const handeloncheng = async (event) => {
    if (event) {
      const resp = await Axios.get(
        `${contextData?.urldashboard}/order/createWorker?workerId=${event?.value}&orderScheduleId=${contextData?.id}`,
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      setSelectedWorkerId(event?.value);
      setCheckingMessage(resp?.data?.message);
      return setCheckModal(true);
    } else {
      handelValue('workerId', event);
    }
  };

  const reloadAfterDelete = () => {
    setReload(!localReload);
    if (contextData?.handleRefreshGridWorker)
      contextData?.handleRefreshGridWorker();
  };

  const handelsubmit = async () => {
    setLoadingFrom(true);
    try {
      const res = await Axios.post(
        `${contextData?.urldashboard}/${
          contextData?.isContractual ? 'order' : controllerName
        }/createworker`,
        JSON.stringify(formData),
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );
      const data = await res.data;
      toaster.success(data.message);
      setReload(!localReload);
      setLoadingFrom(false);
      if (contextData?.handleRefreshGridWorker)
        contextData?.handleRefreshGridWorker();
    } catch (error) {
      setLoadingFrom(false);
      if (error.message === 'Network Error') {
        toaster.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید');
      } else {
        toaster.error(error?.response?.data?.message);
      }
    }
  };

  const reset = () => {
    setCheckModal(false);
    setSelectedWorkerId('');
    setCheckingMessage('');
  };

  const setValue = (value) => {
    dataFeching(value);
  };

  return (
    <>
      <Row>
        <Col span={24} style={{ marginBottom: '1rem' }}>
          <Collapse defaultActiveKey={['0']}>
            <Collapse.Panel header='جستجو طبق خصوصیات' key='1'>
              {/* */}
              <NewSpecialitiesCollapse setValue={setValue} />
            </Collapse.Panel>
          </Collapse>
        </Col>
        <Col span={24}>
          <Form.Group>
            <Form.Label>انتخاب نیرو</Form.Label>
            <Select
              className='basic-single'
              classNamePrefix='select'
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              onChange={handeloncheng}
              isLoading={isLoading}
              isRtl
              isClearable
              name='orderScheduleId'
              options={[
                {
                  label: 'انتخاب نیرو',
                  options: arrystate,
                },
              ]}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Switchrs
          label='آیا روز های کاری نیرو نادیده گرفته شود؟'
          name='ignoreFormOrder'
          handelValue={handelValue}
        />
        {!contextData?.isB2B && (
          <Switchrs
            label='آیا نیرو مورد علاقه است؟'
            name='isFavorite'
            handelValue={handelValue}
          />
        )}
        <Switchrs
          label='دارای خدمات اضافی است ؟'
          name='hasAdditionalService'
          handelValue={handelValue}
        />
        {formData?.workerId ? (
          <Switchrs
            label='آیا نیرو جایگزین است؟'
            name='hasAlternative'
            handelValue={handelValue}
          />
        ) : null}
      </Row>
      {formData?.workerId && formData?.hasAlternative ? (
        <Row className='mt-4'>
          <Col span={12}>
            <InputControlAsync
              url='/worker/search'
              label='نیروی معرفی‌کننده'
              name='presenterId'
              handelValue={(_, value) => handelValue('presenterId', value)}
            />
          </Col>
        </Row>
      ) : null}

      <TabelWorker
        urldata='/WorkerOrderSchedule'
        reloadAvailableWorkes={() => reloadAfterDelete()}
        reload={localReload}
        isform
        itemname='orderScheduleId'
        params={contextData?.id}
        page='1'
        pageSiz='20'
        arryactions={arryactions}
      />

      <Row>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
        >
          {/* <Button
          disabled={loadingFrom}
          variant='danger'
          className='ml-auto'
          onClick={handleCloseMoudal}
        >
          بستن
        </Button> */}
          <Button
            disabled={loadingFrom}
            onClick={handelsubmit}
            variant='success'
          >
            {loadingFrom ? (
              <i className='fa fa-spinner fa-pulse fa-fw'></i>
            ) : (
              'ثبت'
            )}
          </Button>
        </div>
      </Row>

      <Modal show={checkModal} onHide={reset}>
        <Modal.Header>
          <Modal.Title>افزودن نیرو</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>{checkingMessage}</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            key='submit'
            variant='primary'
            onClick={() => {
              handelValue('workerId', selectedWorkerId);
              reset();
            }}
          >
            بله
          </Button>
          <Button key='back' variant='danger' onClick={reset}>
            خیر
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const TabPane2 = ({ contextData }) => {
  const { location } = useHistory();
  const controllerName = location.pathname.split('/')[1].replace('/', '');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dispatchModal, setDispatchModal] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [payIsLoading, setPayIsLoading] = useState(false);
  // selected rows
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    getList({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
      filterData,
    });
  }, []);

  const getList = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/worker/workerSelectionAssistant';
      const res = await Axios.post(
        contextData?.urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          ...filterData,
          orderScheduleId: contextData?.id,
        }),
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getList({
      page: newPage,
      pageSize: newPageSize,
      filterData,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام نیرو',
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره موبایل',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'امتیاز',
      dataIndex: 'rate',
      align: 'center',
    },
    {
      title: 'نزدیکترین نقطه سرویس',
      dataIndex: 'closestServicePoint',
      key: 'closestServicePoint',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'متعهد است؟',
      dataIndex: 'isCommitted',
      key: 'isCommitted',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'خوابگاهی است؟',
      dataIndex: 'isDormitory',
      key: 'isDormitory',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'مورد علاقه است؟',
      dataIndex: 'isFavorite',
      key: 'isFavorite',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'روز قبلی کار داشته است؟',
      dataIndex: 'isPreviousDayWork',
      key: 'isPreviousDayWork',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'تعداد کارها در انبار',
      dataIndex: 'numberOfWorkInStore',
      align: 'center',
    },
    {
      title: 'عملیات',
      dataIndex: 'id',
      key: 'id',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <Button onClick={() => handleCreateWorker(value)}>ثبت عادی</Button>
      ),
    },
  ];

  const handlePay = async () => {
    setPayIsLoading(true);
    try {
      const res = await Axios.post(
        `${contextData?.urldashboard}/jobDispatch/createJobDispatchWorkers`,
        JSON.stringify({
          workerIds: selectedRowKeys,
          orderScheduleId: contextData?.id,
        }),
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      setPayIsLoading(false);
      toaster.success(
        'عملیات با موفقیت انجام شد. نتیجه را از طریق وضعیت نیروهای انتخاب شده، پیگیری نمایید.'
      );
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        filterData,
      });
      setSelectedRowKeys([]);
    } catch (error) {
      contextData?.handelerrors(error);
      setPayIsLoading(false);
    }
  };

  const handleCreateWorker = async (id) => {
    setLoading(true);
    try {
      const res = await Axios.post(
        `${contextData?.urldashboard}/${
          contextData?.isContractual ? 'order' : controllerName
        }/createworker`,
        JSON.stringify({ workerId: id, orderScheduleId: contextData?.id }),
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      setLoading(false);
      toaster.success(
        'عملیات با موفقیت انجام شد. نتیجه را از طریق تب انتخاب نیروی عادی، پیگیری نمایید.'
      );
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        filterData,
      });
      setSelectedRowKeys([]);
    } catch (error) {
      contextData?.handelerrors(error);
      setLoading(false);
    }
  };

  // actions

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const search = () => {
    getList({
      page: 1,
      pageSize: 10,
      filterData,
    });
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={['0']}>
            <Collapse.Panel header='جستجو پیشرفته' key='1'>
              {/* */}
              <Row align={'middle'}>
                <Col span={12}>
                  <InputControl
                    url='/common/getWorkerSelectionAssistantType'
                    label='نوع قانون دستیار انتخاب نیرو'
                    name='workerSelectionAssistantType'
                    handelValue={(_, value) =>
                      handleChange('workerSelectionAssistantType', value)
                    }
                  />
                </Col>
              </Row>
              <Row justify={'end'}>
                <Col span={4}>
                  <Button
                    type='primary'
                    style={{ width: '100%' }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>

      <Row>
        <Col span={24} style={{ margin: '2rem 0' }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Button
              variant='success'
              loading={payIsLoading}
              style={{ height: '3rem' }}
              onClick={() => setDispatchModal(true)}
            >
              وضعیت نیروهای انتخاب شده
            </Button>
            <Button
              disabled={selectedRowKeys.length < 1}
              loading={payIsLoading}
              style={{ height: '3rem' }}
              onClick={handlePay}
            >
              {payIsLoading ? (
                <i className='fa fa-spinner fa-pulse fa-fw'></i>
              ) : (
                'پخش گروهی'
              )}
            </Button>
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={(record) => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        rowSelection={{
          selectedRowKeys,
          onChange: onSelectChange,
        }}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      {dispatchModal ? (
        <ModalJobDispatchWorker
          showitem={dispatchModal}
          handleCloseMoudal={() => setDispatchModal(false)}
          id={contextData?.id}
        />
      ) : null}
    </>
  );
};

const TabPane3 = ({ contextData }) => {
  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [createModal, setCreateModal] = useState(false);

  useEffect(() => {
    getList({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    });
  }, []);

  const getList = async ({ page, pageSize }) => {
    setLoading(true);
    try {
      let url = '/volunteerWorkerOrderSchedule/get';
      const res = await Axios.get(contextData?.urldashboard + url, {
        headers: {
          Authorization: contextData?.authentication,
          'Content-Type': 'application/json',
        },
        params: { page, pageSize, orderScheduleId: contextData?.id },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getList({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام نیرو',
      dataIndex: 'workerName',
      key: 'workerName',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره موبایل',
      dataIndex: 'cellPhone',
      key: 'cellPhone',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تاریخ ثبت',
      dataIndex: 'persianCreateDate',
      key: 'persianCreateDate',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'عملیات',
      dataIndex: 'id',
      key: 'id',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <Space>
          <Button
            onClick={() => handleDelete(value)}
            variant='danger'
            className='ml-auto'
            disabled={loading}
          >
            حذف
          </Button>
          <Button
            onClick={() => {
              setRowId(record?.workerId);
              setCreateModal(true);
            }}
          >
            ثبت عادی
          </Button>
        </Space>
      ),
    },
  ];

  const handleDelete = async (id) => {
    try {
      const res = await Axios.delete(
        `${contextData?.urldashboard}/volunteerWorkerOrderSchedule/delete`,
        {
          headers: {
            Authorization: contextData?.authentication,
            'Content-Type': 'application/json',
          },
          data: {
            id,
          },
        }
      );
      const data = res?.data;
      toaster.success(data.message);
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
      });
    } catch (error) {
      contextData?.handelerrors(error);
    }
  };

  return (
    <>
      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={(record) => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      {createModal && (
        <CreateWorkerFromVoluntary
          openModal={createModal}
          close={() => {
            setRowId('');
            setCreateModal(false);
          }}
          workerId={rowId}
          orderScheduleId={contextData?.id}
        />
      )}
    </>
  );
};

const TabPane4 = ({ contextData }) => {
  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState([]);
  const [props, setProps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [createModal, setCreateModal] = useState(false);

  useEffect(() => {
    getList({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
      specificationIds: props,
    });
  }, []);

  const getList = async ({ page, pageSize, specificationIds = [] }) => {
    setLoading(true);
    try {
      let url = '/worker/availableForContractualOrder';
      const res = await Axios.get(contextData?.urldashboard + url, {
        headers: {
          Authorization: contextData?.authentication,
          'Content-Type': 'application/json',
        },
        params: {
          page,
          pageSize,
          orderScheduleId: contextData?.id,
          specificationIds,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.workerId }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getList({
      page: newPage,
      pageSize: newPageSize,
      specificationIds: props,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام نیرو',
      dataIndex: 'fullName',
      key: 'fullName',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره موبایل',
      dataIndex: 'cellPhone',
      key: 'cellPhone',
      align: 'center',
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'فعال',
      dataIndex: 'isReadyToWork',
      key: 'isReadyToWork',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'تعداد کار',
      dataIndex: 'workCount',
      key: 'workCount',
      align: 'center',
    },
    {
      title: 'تعداد مرخصی',
      dataIndex: 'leaveCount',
      key: 'leaveCount',
      align: 'center',
    },
    {
      title: 'روزهای کاری',
      dataIndex: 'workDayNames',
      key: 'workDayNames',
      responsive: ['xl', 'lg'],
      render: (values) => (
        <Space>
          {values?.map((item) => (
            <Tag color={'#7c7c7c'}>{item}</Tag>
          ))}
        </Space>
      ),
    },
    {
      title: 'عملیات',
      dataIndex: 'workerId',
      key: 'workerId',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <Space>
          <Button
            onClick={() => {
              setRowId(value);
              setCreateModal(true);
            }}
          >
            ثبت عادی
          </Button>
        </Space>
      ),
    },
  ];

  const setValue = (value) => {
    setProps(value);
    getList({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
      specificationIds: value,
    });
  };

  return (
    <>
      <Row>
        <Col span={24} style={{ marginBottom: '1rem' }}>
          <Collapse defaultActiveKey={['0']}>
            <Collapse.Panel header='جستجو طبق خصوصیات' key='1'>
              {/* */}
              <NewSpecialitiesCollapse setValue={setValue} />
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={(record) => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      {createModal && (
        <CreateWorkerFromVoluntary
          openModal={createModal}
          close={() => {
            setRowId('');
            setCreateModal(false);
          }}
          workerId={rowId}
          orderScheduleId={contextData?.id}
        />
      )}
    </>
  );
};

export default ModalCreateworker;
